const lowerPerformanceForESGInvestments = {
    yes: 'Oui',
    no: 'Non',
};
export default lowerPerformanceForESGInvestments;
